import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, Download, Calendar, ArrowLeft, GraduationCap } from 'lucide-react';

import api from '../api/axios';

export default function Certificates() {
  const navigate = useNavigate();
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => {
    api.get('/certificates/my').then(r => { setCertificates(r.data); setLoading(false); });
  }, []);

  const downloadCert = async (code) => {
    try {
      const response = await fetch(
        '/api/certificates/download/' + code + '?token=' + token
      );

      if (!response.ok) {
        throw new Error('Sertifika indirilemedi');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'sertifika-' + code + '.pdf';

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Sertifika indirme hatası:', error);
      alert('Sertifika indirilemedi.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0f2f5 0%, #e8eaf6 100%)' }}>
      <div style={{ background: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(0,0,0,0.07)', padding: '0 32px', height: 60, display: 'flex', alignItems: 'center', gap: 16, position: 'sticky', top: 0, zIndex: 100 }}>
        <button onClick={() => navigate('/panel')} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, color: '#E30613', fontWeight: 600, fontSize: 13 }}>
          <ArrowLeft size={16} /> Geri
        </button>
        <div style={{ width: 1, height: 20, background: 'rgba(0,0,0,0.1)' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Award size={18} color="#E30613" />
          <span style={{ fontWeight: 700, fontSize: 16, color: '#1a1a2e' }}>Sertifikalarim</span>
        </div>
      </div>
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '32px 24px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>Yükleniyor...</div>
        ) : certificates.length === 0 ? (
          <div style={{ background: 'rgba(255,255,255,0.8)', borderRadius: 20, padding: 60, textAlign: 'center', border: '1px solid rgba(255,255,255,0.9)' }}>
            <GraduationCap size={56} color="#d1d5db" strokeWidth={1} style={{ margin: '0 auto 16px' }} />
            <div style={{ fontWeight: 700, fontSize: 18, color: '#374151', marginBottom: 8 }}>Henuz sertifikaniz yok</div>
            <div style={{ color: '#9ca3af', fontSize: 14, marginBottom: 24 }}>Eğitimleri tamamlayarak sertifika kazanabilirsiniz.</div>
            <button onClick={() => navigate('/panel')} style={{ background: 'linear-gradient(135deg, #E30613, #8b0000)', color: 'white', border: 'none', borderRadius: 12, padding: '12px 28px', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>Eğitimlere Git</button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 24 }}>
              <div style={{ background: 'linear-gradient(135deg, #E30613, #8b0000)', borderRadius: 12, padding: '8px 16px', color: 'white', fontWeight: 700, fontSize: 13, display: 'inline-block' }}>{certificates.length} Sertifika</div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: 16 }}>
              {certificates.map(cert => (
                <div key={cert.id} style={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(10px)', borderRadius: 20, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.9)', boxShadow: '0 4px 20px rgba(0,0,0,0.07)', transition: 'all 0.2s' }}
                  onMouseEnter={e => { e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 12px 36px rgba(0,0,0,0.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 4px 20px rgba(0,0,0,0.07)'; }}>
                  <div style={{ background: 'linear-gradient(135deg, #0f172a, #cc0000)', padding: '28px 28px 24px', position: 'relative', overflow: 'hidden' }}>
                    <div style={{ position: 'absolute', top: -20, right: -20, width: 120, height: 120, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, position: 'relative' }}>
                      <div style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Award size={22} color="white" strokeWidth={1.5} />
                      </div>
                      <div>
                        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase' }}>Basari Sertifikasi</div>
                        <div style={{ fontSize: 13, color: 'white', fontWeight: 600, marginTop: 1 }}>Petlas Eğitim ve Akademi</div>
                      </div>
                    </div>
                    <div style={{ fontSize: 17, fontWeight: 700, color: 'white', lineHeight: 1.3, position: 'relative' }}>{cert.course_title}</div>
                  </div>
                  <div style={{ padding: '18px 24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6b7280', fontSize: 12 }}>
                        <Calendar size={13} />
                        {new Date(cert.issued_at).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                      </div>
                      <div style={{ background: 'rgba(52,199,89,0.1)', color: '#34c759', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 700 }}>✓ Tamamlandı</div>
                    </div>
                    <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 16, fontFamily: 'monospace', background: 'rgba(0,0,0,0.03)', padding: '6px 10px', borderRadius: 8 }}>{cert.certificate_code}</div>
                    <button onClick={() => downloadCert(cert.certificate_code)}
                      style={{ width: '100%', padding: '11px', background: 'linear-gradient(135deg, #E30613, #8b0000)', color: 'white', border: 'none', borderRadius: 12, cursor: 'pointer', fontWeight: 700, fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                      <Download size={15} /> PDF Indir
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
